"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvoiceCurrencyEnum = void 0;
var InvoiceCurrencyEnum;
(function (InvoiceCurrencyEnum) {
    InvoiceCurrencyEnum["EUR"] = "EUR";
    InvoiceCurrencyEnum["SEK"] = "SEK";
    InvoiceCurrencyEnum["USD"] = "USD";
})(InvoiceCurrencyEnum = exports.InvoiceCurrencyEnum || (exports.InvoiceCurrencyEnum = {}));
